import { AnalyticsEvents } from '../types/events'
import type { AnalyticsEventProperties } from '../types/properties'

export type PendoAction = 'page_view' | 'element_clicked' | 'navigation_clicked'

function kebabToSnake(value: string): string {
  return value.replace(/-/g, '_')
}

/** createElementId(page, context, element) → `{snake(page)}_{snake(element)}_clicked` for Pendo sub_action. */
function resolveElementSegmentSubAction(properties: AnalyticsEventProperties): string {
  const page = properties.page?.trim()
  const element = properties.element?.trim()
  if (!element) return 'element_clicked'
  const elementPart = kebabToSnake(element)
  if (!page) return `${elementPart}_clicked`
  return `${kebabToSnake(page)}_${elementPart}_clicked`
}

function resolveSubActionFromCatalogWire(wireEvent: string): string {
  if (wireEvent.endsWith('_event')) return wireEvent.slice(0, -'_event'.length)
  return wireEvent
}

export function resolvePendoActionSubAction(
  wireEvent: string,
  properties: AnalyticsEventProperties = {}
): { action: PendoAction; sub_action: string } {
  let resolved: { action: PendoAction; sub_action: string }

  if (wireEvent === AnalyticsEvents.PAGE_VIEW) {
    resolved = { action: 'page_view', sub_action: 'page_view' }
  } else if (wireEvent === AnalyticsEvents.ELEMENT_CLICKED) {
    resolved = { action: 'element_clicked', sub_action: resolveElementSegmentSubAction(properties) }
  } else if (wireEvent.endsWith('_clicked')) {
    resolved = { action: 'element_clicked', sub_action: resolveElementSegmentSubAction(properties) }
  } else {
    resolved = { action: 'element_clicked', sub_action: resolveSubActionFromCatalogWire(wireEvent) }
  }

  return resolved
}
